export default __webpack_public_path__ + "static/media/apple-touch-icon-180x180.9b79d8f6.png";